module.exports = __webpack_public_path__ + "static/media/md-rainy.2121352c.svg";